import '@eg-maps/commons';
import '../node_modules/@eg-maps/base/public/index.bundle.esm.js';
import { UitkPageLoader } from 'uitk-react-loader';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { defaultConfig } from '@eg-maps/core';
import * as React from 'react';
import { LocalizedText } from '@shared-ui/localization-context';
import '../types/uitk-eg-map-marker-type.esm.js';
import { UitkEGMapsType } from '../types/uitk-eg-map-props.esm.js';
import { initGoogleMapsApi } from './google-api.esm.js';
import { initMapBoxApi } from './mapbox-api.esm.js';

/* eslint-disable import/no-extraneous-dependencies */
var useIsMounted = function () {
    var isMounted = React.useRef(false);
    React.useEffect(function () {
        isMounted.current = true;
        return function () {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
var UitkEGMapsScriptLoader = function (_a) {
    var width = _a.width, height = _a.height, mapType = _a.mapType, accessToken = _a.accessToken, children = _a.children, locale = _a.locale, googleMapsId = _a.googleMapsId, _b = _a.reloadMapProviderSDK, reloadMapProviderSDK = _b === void 0 ? false : _b;
    var isMounted = useIsMounted();
    var _c = React.useState(1), loadingCount = _c[0], setLoadingCount = _c[1];
    var _d = React.useState(), error = _d[0], setError = _d[1];
    var egMapsConfig = defaultConfig();
    React.useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        switch (mapType) {
            case UitkEGMapsType.GOOGLE:
                {
                    var baseUrl = (_b = (_a = egMapsConfig.googleMaps) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.api;
                    if (baseUrl) {
                        initGoogleMapsApi(reloadMapProviderSDK, { baseUrl: baseUrl, accessToken: accessToken, mapId: googleMapsId, locale: locale })
                            .then(function () {
                            if (isMounted.current) {
                                setLoadingCount(0);
                            }
                        })
                            .catch(function (err) { return setError(err.message); });
                    }
                    else
                        setError('No base URL found in eg-maps config to load google maps sdk');
                }
                break;
            case UitkEGMapsType.MAPBOX:
                {
                    var jsUrl = (_d = (_c = egMapsConfig.mapbox) === null || _c === void 0 ? void 0 : _c.urls) === null || _d === void 0 ? void 0 : _d.api;
                    var cssUrl = (_f = (_e = egMapsConfig.mapbox) === null || _e === void 0 ? void 0 : _e.urls) === null || _f === void 0 ? void 0 : _f.css;
                    var pluginsUrl = ((_h = (_g = egMapsConfig.mapbox) === null || _g === void 0 ? void 0 : _g.urls) === null || _h === void 0 ? void 0 : _h.pluginUrls) || [];
                    initMapBoxApi(reloadMapProviderSDK, { jsUrl: jsUrl, cssUrl: cssUrl, pluginsUrl: pluginsUrl })
                        .then(function () {
                        if (isMounted.current) {
                            setLoadingCount(0);
                        }
                    })
                        .catch(function (err) { return setError(err.message); });
                }
                break;
            default:
                setError("Map provider not supported: ".concat(mapType));
        }
    }, []);
    if (error) {
        return (React.createElement(UitkLayoutPosition, { type: "relative", position: { top: 'center', left: 'center' } },
            React.createElement("div", null,
                React.createElement("p", null,
                    React.createElement(LocalizedText, { message: error })))));
    }
    if (loadingCount > 0) {
        return (React.createElement("div", { style: { width: width, height: height } },
            React.createElement(UitkLayoutPosition, { type: "relative", position: { top: 'center', left: 'center' } },
                React.createElement(UitkPageLoader, { visible: true }))));
    }
    return React.createElement(React.Fragment, null, children);
};

export { UitkEGMapsScriptLoader, useIsMounted };
